import { ImageData, ProductConfigurationMode, ProductFamilyData } from '../../../data/model';
import { ProductInfoTranslation } from '../../../localization/SiteTranslation';
import { StoreUrl } from '../../../shared/StoreUrl';
import { RelativeUrl } from '../../../shared/Url';

export default class ModularProductDetailsState {
  public readonly description: string;
  public readonly icons: ImageData[];
  public readonly image: ImageData;
  public readonly name: string;
  public readonly configuratorUrl?: RelativeUrl;

  public constructor(
    productFamilyData: ProductFamilyData,
    public readonly translation: ProductInfoTranslation,
  ) {
    this.description = productFamilyData.description;
    this.icons = productFamilyData.listingIcons;
    this.image = productFamilyData.mainImage;
    this.name = productFamilyData.name;

    if (productFamilyData.configurationMode === ProductConfigurationMode.Modular) {
      this.configuratorUrl = StoreUrl.modularConfiguratorUrl(productFamilyData.id);
    }
  }
}
